import { useMutation, useQueryClient } from "@tanstack/react-query";
import { organizacionManualApi } from "@/features/organizacion-manual/services/organizacion-manual.api";
import { qk } from "@/lib/query-keys";
import { toastErrorApi, toastExito } from "@/lib/toast";

export function useSeleccionarOrganizacionManual(solicitudId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (organizacionId: string) => organizacionManualApi.seleccionar(solicitudId, organizacionId),
    onSuccess: (solicitud) => {
      qc.setQueryData(qk.solicitud(solicitudId), solicitud);
      toastExito({ title: "Organización asignada", message: `${solicitud.organizacion?.nombre ?? ""} · continúa con los datos generales.` });
    },
    onError: toastErrorApi,
  });
}
